<script setup lang="ts">

import ShipCurrentActionMove
  from '@/components/Sections/Command/Ships/ShipDetails/ShipDetailTabs/ShipActions/Current/Actions/ShipCurrentActionMove.vue'
import ShipCurrentActionAttack
  from '@/components/Sections/Command/Ships/ShipDetails/ShipDetailTabs/ShipActions/Current/Actions/ShipCurrentActionAttack.vue'
import ShipCurrentActionSettle
  from '@/components/Sections/Command/Ships/ShipDetails/ShipDetailTabs/ShipActions/Current/Actions/ShipCurrentActionSettle.vue'
import ShipCurrentActionFollow
  from '@/components/Sections/Command/Ships/ShipDetails/ShipDetailTabs/ShipActions/Current/Actions/ShipCurrentActionFollow.vue'
import ShipCurrentActionExplore
  from '@/components/Sections/Command/Ships/ShipDetails/ShipDetailTabs/ShipActions/Current/Actions/ShipCurrentActionExplore.vue'
import ShipCurrentActionFollowAttack
  from '@/components/Sections/Command/Ships/ShipDetails/ShipDetailTabs/ShipActions/Current/Actions/ShipCurrentActionFollowAttack.vue'
import ShipCurrentActionRepair
  from '@/components/Sections/Command/Ships/ShipDetails/ShipDetailTabs/ShipActions/Current/Actions/ShipCurrentActionRepair.vue'
import ShipCurrentActionDefend
  from '@/components/Sections/Command/Ships/ShipDetails/ShipDetailTabs/ShipActions/Current/Actions/ShipCurrentActionDefend.vue'
import ShipCurrentActionWait
  from '@/components/Sections/Command/Ships/ShipDetails/ShipDetailTabs/ShipActions/Current/Actions/ShipCurrentActionWait.vue'
import ShipCurrentActionPatrol
  from '@/components/Sections/Command/Ships/ShipDetails/ShipDetailTabs/ShipActions/Current/Actions/ShipCurrentActionPatrol.vue'
import ShipCurrentActionPatrolDefend
  from '@/components/Sections/Command/Ships/ShipDetails/ShipDetailTabs/ShipActions/Current/Actions/ShipCurrentActionPatrolDefend.vue'

/**
 * Props
 */
defineProps<{
  shipActionData: {
    action: string;
    targetX: number;
    targetY: number;
    targetPlayer: number;
    targetShip: number;
    data: {
      name: string;
      type: number;
      typeVariantId: number;
      targetPlayer: number;
    }
  },
  eta: number
}>();

</script>

<template>
  <div v-if="shipActionData.action === 'move'">
    <ShipCurrentActionMove :shipActionData="shipActionData" :eta="eta"/>
  </div>
  <div v-if="shipActionData.action === 'attack'">
    <ShipCurrentActionAttack :shipActionData="shipActionData" :eta="eta"/>
  </div>
  <div v-if="shipActionData.action === 'settle'">
    <ShipCurrentActionSettle :shipActionData="shipActionData" :eta="eta"/>
  </div>
  <div v-if="shipActionData.action === 'follow'">
    <ShipCurrentActionFollow :shipActionData="shipActionData" :eta="eta"/>
  </div>
  <div v-if="shipActionData.action === 'followAttack'">
    <ShipCurrentActionFollowAttack :shipActionData="shipActionData" :eta="eta"/>
  </div>
  <div v-if="shipActionData.action === 'explore'">
    <ShipCurrentActionExplore :shipActionData="shipActionData" :eta="eta"/>
  </div>
  <div v-if="shipActionData.action === 'repair'">
    <ShipCurrentActionRepair :shipActionData="shipActionData" :eta="eta"/>
  </div>
  <div v-if="shipActionData.action === 'defend'">
    <ShipCurrentActionDefend :shipActionData="shipActionData" :eta="eta"/>
  </div>
  <div v-if="shipActionData.action === 'wait'">
    <ShipCurrentActionWait :shipActionData="shipActionData" :eta="eta"/>
  </div>
  <div v-if="shipActionData.action === 'patrol'">
    <ShipCurrentActionPatrol :shipActionData="shipActionData" :eta="eta"/>
  </div>
  <div v-if="shipActionData.action === 'patrolDefend'">
    <ShipCurrentActionPatrolDefend :shipActionData="shipActionData" :eta="eta"/>
  </div>
</template>

<style scoped lang="scss">

</style>